import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import moment from 'moment-timezone';
import { getHeaders, getOverrideAgency } from '@mummssoftware/utils/utils';
import { SET_GLOBAL_PATIENT } from './constants';

/**
 * Fetch patient header and update global patient state.
 * Returns the patient on success, null on failure (does not throw).
 * Callers that keep a local patient copy should update it from the return value.
 */
export const refreshGlobalPatientHeader = async (pim, dispatch, patientNumber, agency) => {
  if (!patientNumber) {
    return null;
  }

  const patient = await pim.getPatientHeader(patientNumber, agency);

  if (patient instanceof Response) {
    return null;
  }

  dispatch({
    type: SET_GLOBAL_PATIENT,
    payload: patient
  });
  return patient;
};
export const getPatientDateRestrictions = async (keycloak, agency, patient, currentUser) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak === null || keycloak === void 0 ? void 0 : keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let authProxyUrl = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/getpatientdaterestrictions?agency=${agency}`;
  authProxyUrl += `&p_patientnumber=${patient === null || patient === void 0 ? void 0 : patient.patientNumber}`;
  const response = await fetch(authProxyUrl, {
    headers,
    credentials: 'same-origin'
  }); // A 504 is a Gateway Timeout Error

  if (response.status === 200) {
    const patientDateRestrictions = await response.json();
    const updatedPatientDateRestrictions = getPatientDateRestrictionsMap(patientDateRestrictions, patient, currentUser);
    return updatedPatientDateRestrictions;
  }

  return null;
};
/**
 case when ignoreconfig is set
    use: coalesce(admissiondate,referraldate)
case when ignoreconfig is NOT set
    use max of coalesce(coalesce(idgmeetingdate,admissiondate,referraldate) or coalesce(admissiondate,referraldate)
 */

export const getPatientDateRestrictionsMap = (dateRestrictions, patient, currentUser) => {
  var _window$env;

  const patientDateRestrictions = dateRestrictions ? dateRestrictions.reduce((seed, data) => {
    seed[data.type] = data.datetimevalue;
    return seed;
  }, {}) : null;
  /**
      Logic to determine the basic date constraints
      1. Is override agency?
      2. If NO, use last IDG meeting date.
      If IDG meeting date and Admit date, use the latest one. (Scenario: patient was re-admitted / note : backend failure)
      If NO IDG meeting date, use admission date. If no admission date, use referral date.
      3. If YES, use admission date. If no admission date, use referral date.
       */

  let basicDateConstraint;
  const overrideIDGBins = (_window$env = window.env) === null || _window$env === void 0 ? void 0 : _window$env.overrideIDGBins;
  const isIDGOverrideAgency = getOverrideAgency(currentUser, overrideIDGBins); // Patient may not have an admission date yet

  const admissionDate = patient && patient.admissionDate && moment(new Date(patient.admissionDate)); // Patient always have a referral date

  const referralDate = patient && moment(new Date(patient.referralDate));
  const patientDate = admissionDate || referralDate; // 1. Is override agency?

  if (isIDGOverrideAgency) {
    // 2. if yes use admission date or referral date
    basicDateConstraint = patientDate;
  } else {
    // 3. if no use last IDG meeting date or admission date or referral date
    const lastIdgMeetingDate = patientDateRestrictions === null || patientDateRestrictions === void 0 ? void 0 : patientDateRestrictions.lastidg;

    if (lastIdgMeetingDate) {
      // 4. If IDG meeting date and Admit date, use the latest one. (Scenario: patient was re-admitted / note : backend failure)
      const maxAdmitIDGDate = moment.max(moment(admissionDate), moment(lastIdgMeetingDate));
      basicDateConstraint = maxAdmitIDGDate;
    } else {
      basicDateConstraint = patientDate;
    }
  }

  const updatedPatientDateRestrictions = _objectSpread(_objectSpread({}, patientDateRestrictions), {}, {
    basicDateConstraint,
    admissionDate,
    referralDate
  });

  return updatedPatientDateRestrictions;
};